import Ably from 'ably'

export const ablyRest = process.env.ABLY_API_KEY
  ? new Ably.Rest({ key: process.env.ABLY_API_KEY })
  : undefined
